/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Rolespermissionstableintro4Inputs */

const en_usermanagement_help_rolespermissionstableintro4 = /** @type {(inputs: Usermanagement_Help_Rolespermissionstableintro4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a detailed breakdown of the roles and permissions in a comprehensive table format,`)
};

/**
* | output |
* | --- |
* | "For a detailed breakdown of the roles and permissions in a comprehensive table format," |
*
* @param {Usermanagement_Help_Rolespermissionstableintro4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_rolespermissionstableintro4 = /** @type {((inputs?: Usermanagement_Help_Rolespermissionstableintro4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Rolespermissionstableintro4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_rolespermissionstableintro4(inputs)
});
export { usermanagement_help_rolespermissionstableintro4 as "userManagement_help_rolesPermissionsTableIntro" }